module.exports = __webpack_public_path__ + "images/emoji/rainbow.179508221a972524d9a9.png";